/* eslint-disable no-use-before-define */
/* global ksAPI */

const searchInTeam = () => {
  const container = document.querySelector('.js-search-in-team');

  const handleRequest = event => {
    event.preventDefault();
    if (container) {
      const input = container.querySelector('.js-search-in-team-input');
      const results = container.querySelector('.js-search-in-team-results');
      const ajaxUrl = document.querySelector('meta[name="adjx"]').content;
      const restUrl = `${ksAPI.rest.url}wp/v2/`;
      const page = event.target.dataset.link;

      const ajaxData = {
        action: 'ks_get_team_posts',
        rest_url: restUrl,
        lastname: input ? input.value : null,
        page,
        language: document.documentElement.lang,
      };

      const ajaxParameters = Object.entries(ajaxData)
        .map(e => e.join('='))
        .join('&');

      const xhr = new XMLHttpRequest();
      xhr.open('POST', ajaxUrl, true);

      xhr.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded;',
      );

      xhr.onload = () => {
        const { response } = xhr;
        if (!response) {
          return;
        }

        results.innerHTML = response;
        const menu = document.querySelector('.js-candidate-inf-menu');
        const mobile = window.matchMedia('(max-width: 767px)').matches;
        let offset = 0;
        if (menu && mobile) {
          offset = menu.getBoundingClientRect().height;
        }
        window.scrollTo({
          top: results.getBoundingClientRect().top + window.scrollY - offset,
          left: 0,
          behavior: 'smooth',
        });
        clickLinks();
      };
      // eslint-disable-next-line no-unused-vars
      xhr.onerror = response => {
        // eslint-disable-next-line no-console
        // console.error(response);
      };

      xhr.send(ajaxParameters);
    }
  };

  const formSubmit = () => {
    const submit = container.querySelector('.js-search-in-team-submit');
    if (submit) {
      submit.addEventListener('click', handleRequest);
    }
  };

  const clickLinks = () => {
    const parent = container.querySelector('.js-team-pagination');
    if (parent) {
      const links = parent.querySelectorAll('.js-pagination-link');
      links.forEach(link => {
        link.addEventListener('click', handleRequest);
      });
    }
  };

  if (container) {
    formSubmit();
    clickLinks();
  }
};

export default searchInTeam;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/search-in-team.js